export function pick<O extends object, K extends keyof O>(obj: O, ...keys: K[]): Pick<O, K> {
  const result: any = {}
  for (const key of keys) {
    if (key in obj) {
      result[key] = obj[key]
    }
  }
  return result
}
